<template>
  <div id="app">
    <div v-show="$store.state.pageshow">
      <LinePic/>
      <MyHeader/>
      <!-- <keep-alive> -->
      <router-view/>
      <!-- </keep-alive> -->
    </div>
    <iframe src="./mms3D/index.html" id="iframe"></iframe>
  </div>
</template>
<script>
import MyHeader from "@/components/MyHeader.vue"
import LinePic from "@/components/LinePic.vue"
export default {
  components:{
    MyHeader,
    LinePic,
  },
  mounted(){
    // 关闭浏览器窗口的时候清空浏览器缓存在localStorage的数据
    // window.onbeforeunload = function () {
    //     var storage = window.localStorage;
    //     storage.clear()
    // }
    this.$store.commit('changestate_1');
    this.$router.push('/home');
    window.parent['pageshow']=()=>{
      this.$store.commit('changepageshow')
    }
  }
}
</script>>
<style lang="scss">
#iframe{
  width: 100vw;
  height: 100vh;
  border: none;
}
#app{
  // background: url('@/assets/background.png') no-repeat center center;
  // background-size: 100% 100%;
  width: 100vw;
  height: 100vh;
  color: white;
  // box-sizing: border-box;
  overflow: hidden;
}
ul,li{
  list-style: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;

}
*{
  margin: 0;
  padding: 0;
}
.bscroll-vertical-scrollbar{
  display: none !important;
}
.custom-vertical-scrollbar{
   position: absolute;
    top: 50%;
    right: .0625rem;
    height: 6.25rem;
    width: .4375rem;
    border-radius: .375rem;
    transform: translateY(-50%) translateZ(0);
    background-color: rgb(200, 200, 200, 0.3);
    z-index: 10;
}
   
.custom-vertical-indicator{
  width: 100%;
  height: 1.25rem;
  border-radius: .375rem;
  background-color: #ffffff;
}
</style>
